import React, { useState } from 'react';
import Div from '../Div';
import Button from '../Button';
import InfoIcon from '@/components/Icons/InfoIcon';
import classNames from 'classnames';
import useScreen from '@/hooks/useScreen';

type Position = 'top' | 'bottom';

type InfoButtonTooltipProps = {
  tooltipText: string;
  className?: string;
  position?: Position;
  toolTipClassName?: string;
};

const InfoButtonTooltip = ({
  tooltipText,
  position = 'top',
  className,
  toolTipClassName,
}: InfoButtonTooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const { isMobile } = useScreen();
  return (
    <Div className={classNames('relative inline-block', className)}>
      <Button theme="none" onClick={() => setShowTooltip((prev) => !prev)}>
        <InfoIcon />
      </Button>

      {showTooltip && (
        <Div
          className={classNames(
            'absolute transform p-s4 w-[281px] !text-left bg-trans-b80 text-white  rounded shadow-lg',
            toolTipClassName,
            {
              'bottom-full mb-s4 left-1/2 -translate-x-1/2': position === 'top' && !isMobile, // Top and centered
              'top-full mt-s4 left-1/2 -translate-x-1/2': position === 'bottom' && !isMobile, // Bottom and centered
              'bottom-full mb-s4 right-0 translate-x-0': position === 'top' && isMobile, // Top and right for mobile
              'top-full mt-s4 right-0 translate-x-0': position === 'bottom' && isMobile, // Bottom and right for mobile
            },
          )}
        >
          {tooltipText}
          <Div
            className={classNames(
              'absolute transform rounded-b-lg translate-y-full w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-trans-b80',
              {
                'left-1/2 -translate-x-1/2': !isMobile, // Center for non-mobile
                'right-s1 translate-x-0': isMobile, // Right-aligned for mobile
                'top-0 -translate-y-full': position === 'bottom', // Triangle above for bottom position
                'bottom-0 translate-y-full': position === 'top', // Triangle below for top position
              },
            )}
            forceRender
          />
        </Div>
      )}
    </Div>
  );
};

export default InfoButtonTooltip;
